module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-appt parallax",
    style: ({
      backgroundImage: "url(" + _vm.content.parallax[1].photo + ")"
    })
  }, [_c('div', {
    staticClass: "home-appt__content"
  }, [_c('div', {
    staticClass: "home-appt__content-title"
  }, [_vm._v("schedule your complimentary consultation")]), _c('div', {
    staticClass: "btn-main home-appt__content-btn",
    on: {
      "click": function($event) {
        _vm.showApptModal = true
      }
    }
  }, [_vm._v("Request Appointment")])]), (_vm.showApptModal) ? _c('ApptModal', {
    on: {
      "close": function($event) {
        _vm.showApptModal = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d71682c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-home-appt/custom-home-appt.pug
// module id = 616
// module chunks = 1